module.exports = new __parcel__URL__("userPermissions.7b801eb7.svg").toString();